module.exports = __webpack_public_path__ + "static/media/38-8.3af4243b.mp3";